export default __webpack_public_path__ + "static/media/promocode_pc_Cn.34de979a.webp";